export default __webpack_public_path__ + "static/media/model_s.e3d22a07.jpeg";